export const UC_DISALLOWED_TILDE_MESSAGE = 'The symbol is not allowed on the UC app';

const UC_BOUND_TOKENS = new Set([
  'span-uc-logo',
  'span-cm-uc-logo',
  'span-uc-csu-logo',
  'uc-flag',
]);

export const containsDisallowedUcTilde = (value: unknown) =>
  typeof value === 'string' && value.includes('~');

export const isUcBoundInput = (logo?: string, className?: string) =>
  `${logo ?? ''} ${className ?? ''}`
    .split(/\s+/)
    .some((token) => UC_BOUND_TOKENS.has(token));

export const shouldWarnUcTilde = (value: unknown, logo?: string, className?: string) =>
  isUcBoundInput(logo, className) && containsDisallowedUcTilde(value);
